// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"cdc82947","351":"8cc9b445","367":"195d0d45","689":"47ca3702","888":"92b351bd"}[chunkId] + ".chunk.js";
};